module.exports = __webpack_public_path__ + "img/avicennaLogo.29d76ec5.svg";